import { render, staticRenderFns } from "./CBSQueueTable.vue?vue&type=template&id=d2da945e&"
import script from "./CBSQueueTable.vue?vue&type=script&lang=js&"
export * from "./CBSQueueTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports